import { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import SwiperCore, { Navigation, Autoplay } from 'swiper';
import { IonicSwiper, IonCard, IonCardHeader, IonCardTitle, IonCardContent, IonImg, IonIcon, IonText } from '@ionic/react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { calendarOutline, documentTextOutline } from 'ionicons/icons';
import { Constants } from '../../defines/Constants';
import axios from 'axios';
import Loading from '../Loading';
import './Blog.css';

SwiperCore.use([IonicSwiper, Navigation, Autoplay]);
const Blog = () => {
    const [blog, setBlog] = useState([]);
    const blogApi = Constants.api.blog;
    useEffect(() => {
        const getBlog = async () => {
            try {
                const results = await axios.get(blogApi);
                if (results.status === 200) {
                    setBlog(results.data.blog_items);
                }
            } catch (error: any) {
                console.log(error);
            }
        }
        getBlog();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const history = useHistory();
    const onReadMoreClick = (id: any) => {
        history.push({
            pathname: '/blog',
            state: id
        });
    }
    const blogEl = blog.map((item: any, index: number) =>
        <SwiperSlide key={"index" + index}>
            <IonCard>
                <div>
                    <IonImg src={Constants.uploads + 'blog/' + item.image} onClick={() => onReadMoreClick(item.id)} />
                    <div className="blog-box-date">
                        <IonIcon icon={calendarOutline} />
                        {item.datetime}
                    </div>
                </div>
                <IonCardHeader>
                    <IonCardTitle onClick={() => onReadMoreClick(item.id)}>
                        {item.title}
                    </IonCardTitle>
                </IonCardHeader>
                <IonCardContent>
                    <IonText color="primary" onClick={() => onReadMoreClick(item.id)}>
                        بیشتر بخوانید
                    </IonText>
                </IonCardContent>
            </IonCard>
        </SwiperSlide>
    )
    return (
        <div className="blog-container">
            <h5>
                <IonIcon icon={documentTextOutline} />
                آخرین اخبار و مقالات
            </h5>
            <Swiper
                dir="rtl"
                autoplay={{ "delay": 2500, "disableOnInteraction": false }}
                slidesPerView={1}
                navigation={true}
                className="slider-container"
                allowTouchMove={true}
            >
                {blog.length === 0 ?
                    <Loading />
                    :
                    blogEl
                }
            </Swiper>
        </div>
    );
};
export default Blog;